import { motion } from 'framer-motion';
import styled from 'styled-components';

export interface IGrid {
	flex?: 'start' | 'end' | 'between' | 'center';
	flex_option?: string;
	direction?: 'column' | 'row';
	align_items?: 'start' | 'end' | 'center' | 'stretch';
	wrap?: 'wrap' | 'nowrap';
	_width?: string;
	_margin?: string;
	_padding?: string;
	_height?: string;
	align?: 'left' | 'center' | 'right';
	_gap?: string;
	_overflow?: 'hidden' | 'visible' | 'auto' | 'overlay';
}

export interface IText {
	typo?: 'span' | 'span_bold' | 'p' | 'p_bold' | 'h4' | 'h3' | 'h2' | 'h1';
	_margin?: string;
	_width?: string;
	white_space?: string;
	color?: string;
	opacity?: number;
	underline?: boolean;
}

const Grid = styled(motion.div)<IGrid>`
	${({ _width }) => (_width ? `width: ${_width}` : `width: 100%`)};
	${({ _height }) => _height && `height: ${_height}`};
	${({ _margin }) => _margin && `margin: ${_margin}`};
	${({ _padding }) => _padding && `padding: ${_padding}`};
	${({ theme, flex }) =>
		flex === 'start'
			? theme.common.flexStart
			: flex === 'end'
			? theme.common.flexEnd
			: flex === 'between'
			? theme.common.flexBetween
			: flex === 'center' && theme.common.flexCenter};
	${({ align_items }) =>
		align_items === 'start'
			? `align-items: flex-start`
			: align_items === 'end'
			? `align-items: flex-end`
			: align_items === 'stretch'
			? `align-items: stretch`
			: align_items === 'center' && `align-items: center`};
	${({ direction }) => direction === 'column' && `flex-direction: column`};
	${({ wrap }) => wrap === 'wrap' && `flex-wrap: wrap`};
	${({ flex_option }) => flex_option && `flex: ${flex_option}`};
	${({ align }) =>
		align === 'left'
			? `text-align: left`
			: align === 'right'
			? `text-align: right`
			: align === 'center' && `text-align: center`};

	${({ _gap }) => _gap && `gap: ${_gap}`};
	${({ _overflow }) => _overflow && `overflow: ${_overflow}`};
`;

const Text = styled.p<IText>`
	${({ white_space }) =>
		white_space ? `white-space: ${white_space}` : `white-space: nowrap`};
	${({ _width }) => _width && `width: ${_width}`};
	${({ _margin }) => _margin && `margin: ${_margin}`};

	${({ theme, typo }) =>
		typo === 'span' || typo === 'span_bold' || typo === 'p' || typo === 'p_bold'
			? theme.typo.body[typo]
			: (typo === 'h4' || typo === 'h3' || typo === 'h2' || typo === 'h1') &&
			  theme.typo.title[typo]};

	${({ color }) => color && `color: ${color}`};
	${({ opacity }) => opacity && `opacity: ${opacity}`};
	${({ underline }) => underline && `text-decoration: underline`};
`;

const setting_style = {
	Grid,
	Text,
};

export default setting_style;
